"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Share } from "lucide-react";
import { cn } from "@/lib/utils";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useIsMobile } from "@/hooks/use-mobile";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { useTranslations } from "next-intl";
type Props = {
  title: string;
  options: React.ReactNode;
  aura?: boolean;
  children?: React.ReactNode;
  className?: string;
};
export function ShareButton(t0) {
  const $ = _c(23);
  const {
    title,
    options,
    aura,
    children,
    className
  } = t0;
  const t = useTranslations("common.share");
  const {
    openModal
  } = useModal();
  const [isOpen, setIsOpen] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== openModal || $[1] !== options || $[2] !== title) {
    t1 = () => {
      openModal(ModalTypeEnum.ACTION_SHEET, {
        title,
        children: options
      });
    };
    $[0] = openModal;
    $[1] = options;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleOpenShare = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsPressed(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleMouseDown = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsPressed(false);
      setIsOpen(true);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleMouseUp = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsPressed(false);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleMouseLeave = t4;
  let t5;
  if ($[7] !== aura || $[8] !== children || $[9] !== className || $[10] !== isOpen || $[11] !== isPressed || $[12] !== options || $[13] !== t) {
    t5 = () => <Dialog open={isOpen} onOpenChange={setIsOpen} data-sentry-element="Dialog" data-sentry-component="renderLaptop" data-sentry-source-file="ShareButton.tsx"><DialogTrigger aria-label="Open share dialog" data-sentry-element="DialogTrigger" data-sentry-source-file="ShareButton.tsx"><div className="flex gap-2 items-center hover:underline cursor-pointer" onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave} onClick={_temp}><div className={cn(`flex items-center justify-center transition-transform duration-150 ease-in-out ${isPressed ? "scale-90" : "scale-100"}`, aura && "bg-card/80 hover:bg-card/90 w-10 h-10 rounded-full", className)}><Share className={cn("w-6 h-6", aura ? "text-muted-foreground" : "", className)} data-sentry-element="Share" data-sentry-source-file="ShareButton.tsx" /></div>{children}</div></DialogTrigger><DialogContent className="sm:rounded-3xl" data-sentry-element="DialogContent" data-sentry-source-file="ShareButton.tsx"><DialogTitle className="sr-only" data-sentry-element="DialogTitle" data-sentry-source-file="ShareButton.tsx">{t("title")}</DialogTitle>{options}</DialogContent></Dialog>;
    $[7] = aura;
    $[8] = children;
    $[9] = className;
    $[10] = isOpen;
    $[11] = isPressed;
    $[12] = options;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const renderLaptop = t5;
  let t6;
  if ($[15] !== aura || $[16] !== className || $[17] !== handleOpenShare) {
    t6 = () => <div aria-label="Open share drawer" onClick={e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      handleOpenShare();
    }} data-sentry-component="renderMobile" data-sentry-source-file="ShareButton.tsx"><Share className={cn("w-6 h-6", aura ? "text-muted-foreground" : "", className)} data-sentry-element="Share" data-sentry-source-file="ShareButton.tsx" /></div>;
    $[15] = aura;
    $[16] = className;
    $[17] = handleOpenShare;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const renderMobile = t6;
  let t7;
  if ($[19] !== isMobile || $[20] !== renderLaptop || $[21] !== renderMobile) {
    t7 = isMobile ? renderMobile() : renderLaptop();
    $[19] = isMobile;
    $[20] = renderLaptop;
    $[21] = renderMobile;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}